import { useParams, useLocation } from "react-router-dom";
import ShortContainer from "../Shorts/ShortContainer";
import { WatchPage } from "../WatchPage";

interface WatchPageRouterProps {
  initialData?: any;
}

const WatchPageRouter = ({ initialData }: WatchPageRouterProps) => {
  const { videoID } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const type = query.get("type");

  if (!videoID) return null;

  if (type === "clip" || type === "short") {
    return <ShortContainer />;
  }

  return <WatchPage initialData={initialData} />;
};

export default WatchPageRouter;
